module.exports = "/static/images/org-emblem.svg";